import createGlobalState from "@ui/lib/createGlobalState";
import { ObservableOrder } from "../Observables/useOptions";

export const useDiagnosisFailureOrder = createGlobalState({
  storage: "session",
  key: "diagnosisFailureOrder",
  type: ObservableOrder,
  defaultValue: "DECREASING_IMPACT_ORDER",
  scoped: true,
});
